import { Controller } from "@hotwired/stimulus";

/**
 * 連動するセレクトボックスを制御するコントローラー
 * @example
 * ```html
 * <div data-controller="dependent-select"
 *      data-dependent-select-show-value-value="targetValue">
 *   <select data-dependent-select-target="parent"
 *           data-action="change->dependent-select#toggle">
 *   </select>
 *   <div data-dependent-select-target="dependent">
 *     <!-- 連動して表示/非表示が切り替わる要素 -->
 *   </div>
 * </div>
 * ```
 */
export default class extends Controller {
  static targets = ["parent", "dependent"];
  static values = { showValue: String };

  declare readonly parentTarget: HTMLSelectElement;
  declare readonly dependentTargets: HTMLElement[];
  declare readonly showValueValue: string;

  toggle(): void {
    const selectedValue = this.parentTarget.value;

    this.dependentTargets.forEach((target) => {
      if (this.showValueValue === selectedValue) {
        target.classList.remove("d-none");
      } else {
        target.classList.add("d-none");
      }
    });
  }

  connect(): void {
    this.toggle();
  }
}
